import { render, staticRenderFns } from "./ModalEditProject.vue?vue&type=template&id=3f84c614&scoped=true&"
import script from "./ModalEditProject.vue?vue&type=script&lang=js&"
export * from "./ModalEditProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84c614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f84c614')) {
      api.createRecord('3f84c614', component.options)
    } else {
      api.reload('3f84c614', component.options)
    }
    module.hot.accept("./ModalEditProject.vue?vue&type=template&id=3f84c614&scoped=true&", function () {
      api.rerender('3f84c614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalEditProject.vue"
export default component.exports